import { render, staticRenderFns } from "./FIFForm.vue?vue&type=template&id=fbef5a16&"
import script from "./FIFForm.vue?vue&type=script&lang=ts&"
export * from "./FIFForm.vue?vue&type=script&lang=ts&"
import style0 from "./FIFForm.vue?vue&type=style&index=0&id=fbef5a16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports